.Timeline {
  --bulletY: calc(var(--base-size-8) / 2 - var(--brand-Timeline-bullet-size) / 2 + var(--base-size-8));

  margin: 0;
  padding: 0;
  list-style: none;
}

.Timeline__item {
  position: relative;
  max-width: var(--brand-Timeline-lineLength);
  padding-inline-start: calc(var(--brand-Timeline-bullet-size) + var(--brand-Timeline-spacing));
  color: var(--brand-color-text-default);
  line-height: var(--brand-Timeline-lineHeight);
}

.Timeline--full-width .Timeline__item {
  max-width: none;
}

.Timeline__item:not(:last-child) {
  padding-bottom: var(--base-size-32);
}

.Timeline__item::before,
.Timeline__item::after {
  content: '';
  position: absolute;
}

.Timeline__item::before {
  width: var(--brand-Timeline-bullet-size);
  height: var(--brand-Timeline-bullet-size);
  top: var(--bulletY);
  left: 0;
  border-style: solid;
  border-width: var(--brand-Timeline-strokeWidth);
  border-color: var(--brand-Timeline-line-color);
  border-radius: var(--brand-borderRadius-full);
}

.Timeline__item:not(:last-child)::after {
  top: calc(var(--bulletY) + var(--brand-Timeline-bullet-size) + var(--brand-Timeline-bullet-spacing));
  left: calc(var(--brand-Timeline-bullet-size) / 2 - var(--brand-Timeline-strokeWidth) / 2);
  width: var(--brand-Timeline-strokeWidth);
  height: calc(100% - var(--brand-Timeline-bullet-size) - var(--brand-Timeline-bullet-spacing) * 2);
  background-color: var(--brand-Timeline-line-color);
  border-radius: var(--brand-borderRadius-full);
}

.Timeline__item-text em,
.Timeline__item-text b {
  color: var(--brand-color-text-default);
  font-style: normal;
  font-weight: var(--base-text-weight-medium);
}

.Timeline__item a {
  color: var(--brand-InlineLink-color-rest);
  position: relative;
  text-decoration: underline;
  text-decoration-color: var(--brand-InlineLink-color-rest);
  text-decoration-thickness: var(--brand-borderWidth-thin);
  text-underline-position: under;
  transition: var(--brand-InlineLink-transition-timing) text-decoration;
}

.Timeline__item a:hover {
  text-decoration-thickness: var(--brand-borderWidth-thick);
}

.Timeline__item a {
  font-weight: inherit;
  color: var(--brand-InlineLink-color-rest);
}

.Timeline__item a:active {
  color: var(--brand-InlineLink-color-pressed);
}

.Timeline__item a:focus-visible {
  outline: var(--brand-borderWidth-thick) solid var(--brand-color-focus);
  outline-offset: var(--base-size-2);
}

/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  .Timeline__item,
  .Timeline__item::before,
  .Timeline__item::after,
  .Timeline__item * {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
